import { cx } from "../../lib/cx.js";
import { Button } from "../Button/Button.js";
import { Tooltip } from "../Tooltip/Tooltip.js";
/* empty css               */
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/IconButton/IconButton.tsx
/**
* A square, icon-only Button. Its hit area is at least `--target-min`, even when it is
* drawn smaller.
*/
var IconButton = forwardRef(function IconButton({ icon, variant = "ghost", size = "md", tooltip = false, className, ...rest }, ref) {
	const button = /* @__PURE__ */ jsx(Button, {
		ref,
		...rest,
		variant,
		size,
		iconOnly: true,
		leadingIcon: icon,
		className: cx("ds-icon-button", `ds-icon-button--${size}`, className)
	});
	if (!tooltip) return button;
	return /* @__PURE__ */ jsx(Tooltip, {
		content: rest["aria-label"],
		placement: tooltip === true ? "top" : tooltip,
		describes: false,
		children: button
	});
});
//#endregion
export { IconButton };

//# sourceMappingURL=IconButton.js.map